/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M5 12l14 0", "key": "svg-0" }], ["path", { "d": "M5 12l4 4", "key": "svg-1" }], ["path", { "d": "M5 12l4 -4", "key": "svg-2" }]];
const IconArrowNarrowLeft = createReactComponent("outline", "arrow-narrow-left", "ArrowNarrowLeft", __iconNode);

export { __iconNode, IconArrowNarrowLeft as default };
//# sourceMappingURL=IconArrowNarrowLeft.mjs.map
